// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"674":"412a1d38","965":"ed5f0aed"}[chunkId] + ".js";
};